var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccesoTendedero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Servicios",
    clipPath: "url(#clip0_781_7328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25 6.66699L35 10.0003V18.3337H30V31.667C30 32.109 29.8244 32.5329 29.5118 32.8455C29.1993 33.1581 28.7754 33.3337 28.3333 33.3337H11.6667C11.2246 33.3337 10.8007 33.1581 10.4882 32.8455C10.1756 32.5329 10 32.109 10 31.667V18.3337H5V10.0003L15 6.66699C15 7.99307 15.5268 9.26484 16.4645 10.2025C17.4021 11.1402 18.6739 11.667 20 11.667C21.3261 11.667 22.5979 11.1402 23.5355 10.2025C24.4732 9.26484 25 7.99307 25 6.66699Z",
    stroke: "#FF7901",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 20",
    d: "M11.6667 11.6663V3.33301",
    stroke: "#FF7901",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M28.3333 11.6663V3.33301",
    stroke: "#FF7901",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_7328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccesoTendedero);
export default __webpack_public_path__ + "static/media/accesoTendedero.8bd70c49141708cd517796f7ed256022.svg";
export { ForwardRef as ReactComponent };